import { Text } from '@user-portal/wikr-components';
import styled from 'styled-components';

import mediaQueries from '@/theme/mediaQueries';

export const Title = styled(Text)`
    margin-left: 16px;
`;

export const PlanContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 24px 16px;

    ${mediaQueries.laptop} {
        padding: 48px 0 48px 96px;
        max-width: 600px;
    }
`;
